import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import './TeamCard.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const TeamCard = ({data}) => {
  const cardRef = useRef(null);
  const [placement, setPlacement] = useState('right'); // Default placement

  useEffect(() => {
    const handleResize = () => {
      if (cardRef.current) {
        const cardRect = cardRef.current.getBoundingClientRect();
        const screenWidth = window.innerWidth;

        // Check if the card is on the left or right side of the screen
        if (cardRect.left < screenWidth / 2) {
          setPlacement('right');
        } else {
          setPlacement('left');
        }
      }
    };

    // Attach the event listener to the window's resize event
    window.addEventListener('resize', handleResize);

    // Call handleResize initially to set the initial placement
    handleResize();

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
    <div className="team-card-container">
    <OverlayTrigger
        placement={placement}
        delay={{ show: 250, hide: 50 }}
      style={{width: "1200px"}}
      overlay={<Tooltip id="button-tooltip-2">{data.text}</Tooltip>}

    >
    <Card  ref={cardRef} className="team-item" style={{ width: '20rem' }}  bg={'light'} >
      <div className='team-image'>
      <Card.Img  style={{marginTop: '28px'}} src={data.image} alt="Card image" />
      <Card.ImgOverlay>        
      <Card.Img src={'https://static.igem.wiki/teams/4602/wiki/images/team/circle.png'} alt="Card image" />
      </Card.ImgOverlay>
      </div>
      <Card.Body className="team-body">

      <Card.Title>{data.name}</Card.Title>
      <Card.Text>
      {data.role}
      </Card.Text>
      <Card.Text>
      {data.email}
      </Card.Text>
      </Card.Body>

  </Card>
        </OverlayTrigger>

    </div>

      </>
  );
};

export default TeamCard;
